import VueLightbox from './components/Lightbox.vue'

export default VueLightbox
export { VueLightbox}


// WEBPACK FOOTER //
// ./src/index.js